// @ts-check
import { computed } from 'vue';
import { useGetters } from 'vuex-composition-helpers/dist';

export function useDateFormat() {
  const language = useGetters({ language: 'user/language' });
  const format = computed(() =>
    (language === 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy'));

  return format;
}
